// extracted by mini-css-extract-plugin
export default {"hr":"Selector_hr__bNGbs"};